import { RouteParam } from ".";
import { ACTION, MODULE } from "../utils/enums";
import { urls } from "../utils/urls";
import ClosingStockListScreen from "../erp/inventory/closing_stock/closing_stock_landing_screen";
import DeviceInventoryListScreen from "../erp/inventory/closing_stock/device_inventory_screen";
import InventoryStockTrackerScreen from "../erp/inventory/closing_stock/inventory_montly_stock_tracker";
import OldInventoryListing from "../ui/pages/inventory";
import InTransitInventoryScreen from "../erp/inventory/closing_stock/InTransitInventoryScreen";
import BulkStockUploadPage from "../erp/inventory/closing_stock/bulk_stock_upload/BulkStockUploadPage";
import InventoryAuditStockLogsScreen from "../erp/inventory/closing_stock/inventory_audit_stock_logs_screen";
import StockActionRequestsScreen from "../erp/inventory/closing_stock/stock_action_requests_screen";
import StockActionRequestEditScreen from "../erp/inventory/closing_stock/stock_action_request_edit_screen";
import InventoryReportLandingPage from "../erp/inventory/landing_page";

const inventory_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.inventory_home,
    component: InventoryReportLandingPage,
    module: MODULE.device_inventory_panel,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.closing_stock,
    component: ClosingStockListScreen,
    module: MODULE.device_inventory_panel,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.bulk_stock_upload,
    component: BulkStockUploadPage,
    module: MODULE.device_inventory_panel,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.inventory_audit_stock_logs,
    component: InventoryAuditStockLogsScreen,
    module: MODULE.device_inventory_panel,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.stock_action_requests,
    component: StockActionRequestsScreen,
    module: MODULE.audit_stock_upload,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.READ],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.stock_action_request_edit,
    component: StockActionRequestEditScreen,
    module: MODULE.audit_stock_upload,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.CREATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.device_inventory,
    component: DeviceInventoryListScreen,
    module: MODULE.device_inventory_panel,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.prev_device_inventory,
    component: OldInventoryListing,
    module: MODULE.device_inventory_panel,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    path: urls.inventory_tracker,
    component: InventoryStockTrackerScreen,
    module: MODULE.material_panning_viewer,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    path: urls.in_transit_inventory,
    component: InTransitInventoryScreen,
    module: MODULE.device_inventory_panel,
    main_module: MODULE.device_inventory_panel,
    action: [ACTION.CREATE],
    operator: "or",
  },
];

export default inventory_routes;
